<script setup lang="ts">
import { config } from "@/lib/variantConfig";
import { DialogClose, DialogDescription, DialogTitle } from "reka-ui";

const emit = defineEmits(["close"]);
</script>

<template>
  <div class="w-full">
    <img src="/icon_app.svg" class="w-24 mx-auto -mt-4" />
    <div class="p-4">
      <div class="text-center">
        <DialogTitle class="font-black text-2xl mb-2">
          {{ $t("download_modal.title") }}
        </DialogTitle>
        <DialogDescription class="text-text-secondary">
          {{ $t("download_modal.description", [config.strings.app_name]) }}
        </DialogDescription>
      </div>
      <div class="flex-center flex-col md:flex-row gap-2 py-6">
        <a :href="config.links.apple_store_url" target="_blank">
          <img src="../assets/vectors/app_store.svg" alt="" />
        </a>
        <a :href="config.links.google_play_url" target="_blank">
          <img src="../assets/vectors/play_store.svg" alt="" />
        </a>
      </div>
      <DialogClose class="btn-secondary w-full">
        {{ $t("common.close") }}
      </DialogClose>
    </div>
  </div>
</template>
